import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import type { PageActivityEditDTO } from '@next-space/fe-api-idl';
import type { FC } from 'react';

import { CollectionPropertySubject } from '../subject';
import { FeedTemplate } from './feed-template';

export const CollectionPropertyFeed: FC<{ edit: PageActivityEditDTO }> = ({ edit }) => {
  const { t } = useAppTranslation();

  if (!edit.collectionPropertyData) return null;
  const action = (() => {
    switch (edit.type) {
      case 'collectionPropertyCreated':
        return t('components.page_feeds.property_created');
      case 'collectionPropertyChanged':
        return t('components.page_feeds.property_edited');
      case 'collectionPropertyDeleted':
        return t('components.page_feeds.property_deleted');
      default:
        throw new Error('Assertion failed');
    }
  })();
  return (
    <FeedTemplate
      edits={[edit]}
      action={action}
      subject={
        <CollectionPropertySubject
          className="p-1 text-t2-medium"
          schema={edit.collectionPropertyData}
          onClick={() => {}}
        />
      }
      timestamp={edit.timestamp}
      changes={[]}
    />
  );
};
